import Vue from "vue";
import errorHandler from "@/utils/errorHandler";

export default (payload) => {
  const request = errorHandler(
    Vue.$http.post(`/iwarehouse/output_extra/create/`, { supplies: payload })
  );
  return request.then((response) => {
    const data = response.data;
    return data;
  });
};


// WEBPACK FOOTER //
// ./src/services/purchase/requestExtraAmount.js